<template>
    <div class="joinUsDetail">
        <div class="job_detail" v-show="isLogin">
            <div class="detail_table">
                <p>{{end_information.title}} <span class="salary">{{end_information.salary_start}}-{{this.end_information.salary_end}}/{{$t('month')}}</span>
                </p>
                <p>{{$t('experience')+'：'+end_information.company}}</p>
                <p>{{$t('department')+'：'+end_information.experience}}</p>
                <p>{{$t('education')+'：'+end_information.education}}</p>
                <p>{{$t('recruitment')+'：'+end_information.work_type}}</p>
                <p>{{$t('recruitment_number')+'：'+end_information.count}}</p>
                <p>{{$t('release_time')+'：'+end_information.uptime}}</p>
                <p>{{$t('work_address')+'：'+end_information.work_city +end_information.work_position_detail}}</p>
            </div>
            <div class="detail_content" v-html="htmlDecode(end_information.work_introduction)">
            </div>
            <span class="detail_btn" @click="getJob()">{{$t('employ')}}</span>
        </div>

    </div>
</template>

<script>
export default {
  name: "joinUsDetail",
  inject: ["showMsg"],
  data() {
    return {
      isLogin: true,
      id: ""
    };
  },
  created() {
    this.getJobData(this.$route.params.id);
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "footerNav[0]");
  },
  methods: {
    getUserInfo() {
      //判断是否登入
      this.$http({
        method: "post",
        url: this.weburl + "Home/User/checkLogin",
        dataType: "json"
      })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.result) {
              //检测是否用户有简历完整信息；
              this.userInfoData();
            } else {
              this.$router.push({ path: `/login` });
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    getJobData(id) {
      //获取招聘信息
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/job/getJob",
        dataType: "json",
        data: {
          id: id,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.$store.commit("set_end_information", res.data.result);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    getJob() {
      this.getUserInfo();
    },
    userInfoData() {
      this.$http({
        method: "post",
        url: this.weburl + "/home/job/recordStatus",
        dataType: "json"
      })
        .then(res => {
          // console.log(res);
          if (res.data.status === 1) {
            if (res.data.result.empty) {
              //检测是否用户有简历完整信息；
              this.showMsgBox(res.data.result.resume_id);
            } else {
              this.showMsgErrorBox();
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    showMsgBox(id) {
      this.$msgbox({
        cancel: "不，修改简历",
        content:
          "<div  style=' height: 50px;width: 40px;margin:0 auto 10px; background: url(../../../static/img/resume1.png) no-repeat ; background-size: 40px auto;'></div><p style='width: 60%;margin: 0 auto; text-align: center; line-height: 20px;font-size: 1rem;'>是否使用已编辑完成简历投递该简历</p>",
        confirm: "是，应聘职位",
        className: "pop-custom"
      })
        .then(() => {
          // console.log("应聘该职位");
          //提交简历
          this.submitSuccessJob(id);
          // this.$router.push({name: `resume`,params:{id:this.$route.params.id}});
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
          this.$router.push({
            name: `basicInformation`,
            params: { id: this.$route.params.id }
          });
        });
    },
    showMsgErrorBox() {
      this.$msgbox({
        content:
          "<div  style='height: 50px;width: 40px;margin:0 auto 10px; background: url(../../../static/img/resume2.png) no-repeat ; background-size: 40px auto; ' ></div><p style='width: 60%;margin: 0 auto; text-align: center; line-height: 20px;font-size: 1rem;'>请编辑简历或简历个人简历<br>再投递该职位</p>",
        confirm: "建立简历",
        className: "pop-custom"
      })
        .then(() => {
          // this.$router.push({path: `/basicInformation`});
          this.$router.push({
            name: `basicInformation`,
            params: { id: this.$route.params.id }
          });
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
          // this.$router.push({name: `basicInformation`,params:{id:this.$route.params.id}});
        });
    },
    showSuccessBox() {
      //提交成功
      this.$msgbox({
        content:
          "<div  style='height: 50px;width: 40px;margin:0 auto 10px; background: url(../../../static/img/confirm.png) no-repeat ; background-size: 40px auto; ' ></div><p style='width: 60%;margin: 0 auto; text-align: center; line-height: 20px;font-size: 1rem;'>简历已经上传成功<br>请继续投递简历吧！</p>",
        confirm: "继续投递",
        className: "pop-custom"
      })
        .then(() => {
          // this.$router.push({path: `/basicInformation`});
          this.$router.push({ path: `/joinUs` });
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
          // this.$router.push({name: `basicInformation`,params:{id:this.$route.params.id}});
        });
    },
    submitSuccessJob(id) {
      this.$http({
        method: "post",
        url: this.weburl + "/home/job/jobHandle",
        dataType: "json",
        data: {
          job_id: this.$route.params.id,
          resume_id: id
        }
      })
        .then(res => {
          // console.log(res);
          if (res.data.status === 1) {
            //提交成功
            this.showSuccessBox();
          } else {
            this.showMsg("提交失败");
            // this.$router.push({name: `basicInformation`,params:{id:this.$route.params.id}});
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    }
  },
  computed: {
    //计算属性，
    end_information: function() {
      return this.$store.state.endPage.end_information;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.joinUsDetail {
  width: @width;
}

.detail_table {
  &:extend(.detail_content);
  .border-bottom(5px; @bg);
  font-size: @font;
  p {
    line-height: 30px;
    .salary {
      color: @brick_red;
      float: right;
    }
  }
}

.detail_content {
  .box-sizing;
  width: @width;
  padding: 20px;
  line-height: 24px;
}

.detail_btn {
  .btn;
  display: block;
  .width;
}
</style>
